import axiosInstance from "../../interceptor/axiosInstance";
import config from "../../config";
/**
 * Logs in the user by validating credentials against MockAPI.io data.
 * @param {Object} credentials - The user's email and password.
 * @returns {Promise<Object>} - The user data if login is successful.
 * @throws {Error} - If login fails.
 */
const login = async (credentials) => {
  try {
    // Fetch all users from the MockAPI
    console.log("Cread:",credentials);
    // const response = await axiosInstance.post(`${config.API_BASE_URL}/auth/login`, {
      const response = await axiosInstance.post(`/auth/login`, {
      userid:credentials.email,
      password:credentials.password,
    });
    const users = response.data;

    // Validate credentials
    

    if (users.message == "Login successful") {
      // Save user details in localStorage
      localStorage.setItem("user", JSON.stringify(users));
      localStorage.setItem("authToken", JSON.stringify(users.token))
      return users;
    } else {
      throw new Error("Invalid email or password");
    }
  } catch (error) {
    console.error("Error during login:", error);
    throw new Error("Unable to connect to the server. Please try again.");
  }
};

/**
 * Checks if the user is authenticated by verifying localStorage data.
 * @returns {boolean} - True if the user is logged in, false otherwise.
 */
const isAuthenticated = () => {
  const user = localStorage.getItem("authToken");
  return !!user;
};

/**
 * Logs out the user by removing data from localStorage.
 */

const logout = async () => {
  // Step 1: Call the logout API and get threadIds
  const response = await axiosInstance.get(`/auth/logout`);
  
  const threadRaw = response.data?.threadIds;
  const threadIds = typeof threadRaw === "string"
  ? threadRaw.split(",").map((id) => id.trim())
  : Array.isArray(threadRaw)
  ? threadRaw
  : [];

  if (threadIds.length === 0) {
    console.warn("No thread IDs found for logout");
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    return;
  }

  // Step 2: Create WebSocket
  const socket = new WebSocket(config.REACT_APP_WEBSOCKET_URL);

  socket.onopen = () => {
    // Step 3: Loop through thread IDs and send logout messages
    threadIds.forEach((id) => {
      socket.send(
        JSON.stringify({
          type: "message",
          ticketStatus: "logout",
          content: "The agent has gone offline and the chat is now closed.",
          threadId: id,
        })
      );
    });

    // Close socket after sending
    socket.close();

    // Step 4: Remove user session data
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
  };

  socket.onerror = (error) => {
    console.error("WebSocket error:", error);
  };

  socket.onclose = () => {
    console.log("WebSocket closed");
  };
};

export default {
  login,
  isAuthenticated,
  logout,
};
